<template>
  <CBox background-color="white" data-cy="refund-list-filters-header">
    <CFlex data-cy="filters-buttons" justify-content="space-between" padding="24px 16px" margin="-16px -16px 0px -16px">
      <CFlex>
        <CPopover :is-open="showPopover" placement="bottom-start" gutter="16" :close-on-blur="false" :use-portal="true">
          <CPopoverTrigger>
            <CBox display="inline-block">
              <OmtButton
                mr="16px"
                size="sm"
                :variant="filtersHasChanges || hasActivedFilter ? 'solid' : 'outline'"
                leftIcon="sliders-h"
                :iconColor="filtersHasChanges || hasActivedFilter ? 'white' : 'var(--colors-light-primary-gray1)'"
                iconSize="sm"
                border=".5px solid var(--colors-light-secondary-divider)"
                @click.stop="openFiltersModal"
              >
                <OmtTypography
                  as="button-small"
                  :color="filtersHasChanges || hasActivedFilter ? 'white' : 'var(--colors-light-primary-gray1)'"
                >
                  Filtrar
                </OmtTypography>
              </OmtButton>
            </CBox>
          </CPopoverTrigger>
          <CPopoverContent
            z-index="9999"
            bg="white"
            border="1px solid var(--colors-light-secondary-divider)"
            border-radius="8px"
            position="relative"
            mt="4px"
            :w="['calc(100vw - 32px)', 'auto']"
            :max-w="['100vw - 32px', 'auto']"
          >
            <CPopoverArrow left="8px" />
            <CPopoverCloseButton @click="dismissTooltip" bg="white" mt="8px" />
            <CPopoverBody padding="16px">
              <OmtTypography as="p1" color="var(--colors-light-primary-gray1)" mr="16px">
                Clique aqui para selecionar o período dos reembolsos exibidos.
              </OmtTypography>
              <OmtButton
                size="sm"
                variant="solid"
                bg="var(--colors-light-primary-navy-blue)"
                color="white"
                mt="16px"
                height="32px"
                @click="dismissTooltip"
              >
                <OmtTypography as="p0" color="white">Entendi</OmtTypography>
              </OmtButton>
            </CPopoverBody>
          </CPopoverContent>
        </CPopover>
        <slot />
      </CFlex>

      <OmtButton
        data-cy="clean-filters-button"
        variant="ghost"
        size="sm"
        :disabled="!activedFilters.length && !activedSort"
        @click="onClean"
      >
        <OmtTypography as="button-small" color="var(--colors-light-primary-gray1)"> Limpar </OmtTypography>
      </OmtButton>
    </CFlex>

    <CBox
      v-if="showPeriodChip"
      display="inline-flex"
      align-items="center"
      bg="var(--colors-light-primary-light-gray)"
      border-radius="32px"
      padding="8px 16px"
    >
      <OmtTypography as="p2" :color="periodTextColor"> Período: {{ periodLabel }} </OmtTypography>
      <OmtIcons name="close" :color="periodTextColor" size="xs" ml="8px" cursor="pointer" @click="hidePeriodChip" />
    </CBox>

    <OmtSwiper ref="OmtSwiper" data-cy="applied-filters-swiper" :spaceBetween="12">
      <OmtSwiperSlide v-for="(filter, index) in activedFilters" :key="index" width="auto">
        <OmtButton
          size="xs"
          bg="var(--colors-light-primary-light-gray)"
          rightIcon="times"
          iconSize="xs"
          @click="removeFilter(filter.label)"
        >
          <OmtTypography color="var(--colors-light-primary-gray1)" as="p2">
            {{ filter.label }}
          </OmtTypography>
        </OmtButton>
      </OmtSwiperSlide>
    </OmtSwiper>
  </CBox>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import {
  CPopover,
  CPopoverContent,
  CPopoverBody,
  CPopoverArrow,
  CPopoverTrigger,
  CPopoverCloseButton
} from "@chakra-ui/vue";

/**
 * @prop { Boolean } isOpen
 */
export default {
  components: {
    CPopover,
    CPopoverContent,
    CPopoverBody,
    CPopoverArrow,
    CPopoverTrigger,
    CPopoverCloseButton
  },
  props: {
    isOpen: {
      type: Boolean
    },
    filtersHasChanges: {
      type: Boolean
    },
    activedSort: {
      type: String
    }
  },
  data() {
    return {
      headerFilters: [],
      showPopover: false,
      showPeriodChip: true
    };
  },
  mounted() {
    // Aguarda 500ms para exibir o popover
    setTimeout(() => {
      const dismissed = localStorage.getItem("refund_filters_tooltip_dismissed") === "true";
      this.showPopover = !dismissed;
      this.SET_FILTERS_TOOLTIP_ACTIVE(this.showPopover);
    }, 1000);
  },
  methods: {
    ...mapMutations("refund", ["SET_FILTERS_TOOLTIP_ACTIVE"]),
    openFiltersModal() {
      if (this.showPopover) {
        this.showPopover = false;
        this.SET_FILTERS_TOOLTIP_ACTIVE(false);
      }
      this.$emit("update:isOpen", true);
    },
    removeFilter(label) {
      this.headerFilters.forEach(filter => {
        if (filter.label === label) filter.isActive = !filter.isActive;
      });
      this.$emit("change", this.headerFilters);
    },
    onClean() {
      if (this.activedFilters.length > 0) {
        this.headerFilters.forEach(f => (f.isActive = false));
        this.$emit("change", this.headerFilters);
      }
      this.$emit("cleanSorts", "");
    },
    dismissTooltip() {
      this.showPopover = false;
      localStorage.setItem("refund_filters_tooltip_dismissed", "true");
    },
    hidePeriodChip() {
      this.showPeriodChip = false;
    }
  },
  watch: {
    filters(newValues) {
      this.headerFilters = JSON.parse(JSON.stringify(newValues));
    },
    filtersTooltipActive(active) {
      if (this.showPopover !== active) {
        this.showPopover = active;
      }
    },
    showPopover(active) {
      const current = this.filtersTooltipActive;
      if (current !== active && this.$store?.commit) {
        this.$store.commit("refund/SET_FILTERS_TOOLTIP_ACTIVE", active);
      }
    }
  },
  computed: {
    ...mapGetters("refund", ["hasActivedFilter"]),
    ...mapState("refund", ["filters", "selectedPeriod", "filtersTooltipActive"]),
    activedFilters() {
      return this.headerFilters.filter(filter => !!filter.isActive);
    },
    periodLabel() {
      const periodos = ["15 dias", "30 dias", "60 dias", "2 anos"];
      const idx = Number(this.selectedPeriod) || 0;
      return periodos[idx] || periodos[0];
    },
    periodTextColor() {
      return "#8C8C8C";
    }
  }
};
</script>
